module.exports = __webpack_public_path__ + "static/WhenThePastWasAround9-9296f27ff9f2ef49ca5b547198e729c4.webp";